import ComponentBase from 'components/_base/ComponentBase';
import jQuery from 'jquery';
import Handlebars from 'handlebars-template-loader/runtime';

/**
 * @class ToggleBtn
 * @memberof core.components
 *
 * @fires Widget#TOGGLE_PANEL_MENU
 * @fires Widget#TOGGLE_MAIN_MENU
 * @fires Widget#TOGGLE_DRAW_TOOL
 */
const TransportModes = ComponentBase.extend(
    /**
     * @lends core.components.ToggleBtn.prototype
     */
    {

        template: require('./transportModes.hbs'),

        componentClass: 'transport-modes',

        transportTypes: ['transit', 'driving', 'bicycling', 'walking'],

        events: {
            'click': 'toggleBtn'
        },

        /**
         * Initialize the component
         * @function
         * @param {Object} options - The config provided by json
         */
        initialize(config) {
            this.bus = this.widget.bus;
            this.templateConfig.transportTypes = this.transportTypes;
            this.templateConfig.activeTransportType = this.properties.defaultMode;
            this.loadHelpers();
            ComponentBase.prototype.initialize.call(this, config);
        },

        /**
         * Fires the event and toggle class
         * @private
         */
        toggleBtn(event) {
            this.transportTypeEvent = event.target.dataset.transportmode;
            if (this.templateConfig.activeTransportType !== this.transportTypeEvent) {
                this.templateConfig.activeTransportType = this.transportTypeEvent;
                this.$el.replaceWith(this.render().$el);
                this.bus.trigger(this.properties.event, this);
                jQuery(this.el).toggleClass('lmm-active');
            }
        },

        loadHelpers() {
            Handlebars.registerHelper('transportModeActive', function () {
                const args = Array.prototype.slice.call(arguments, 0, -1);
                return args.every(function (expression) {
                    return args[0] === expression;
                });
            });
        }
    });

export default TransportModes;



// WEBPACK FOOTER //
// ./src/components/transportModes/transportModes.js